import { ModuleBase } from "@/modules/base";
import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import AtmosphereLayer from './AtmosphereLayer.vue'
import BackgroundMenu from "./BackgroundMenu.vue";
import { store } from '@/store';

enum BackgroundType {
  NONE = 'NONE',
  ESO_MILKY_WAY = 'ESO_MILKY_WAY',
  GAIA_DR2 = 'GAIA_DR2',
  KAWANOMOTO1 = 'KAWANOMOTO1',
  NHK2 = 'NHK2',
}

@Component
export class BackgroundModule extends Mixins(ModuleBase) {
  frameStore() {
    @Component
    class FrameStore extends Vue {
      type = BackgroundType.ESO_MILKY_WAY
      @Watch('type')
      onTypeChange(b: BackgroundType) {
        if (b !== BackgroundType.KAWANOMOTO1) {
          const globe = store.currentGlobe()
          const coord = globe.viewFactory.center()
          globe.viewFactory.jumpTo({ za: 0, zd: Math.PI / 2, zp: 0 }, { coord, keepFovy: true })
        }
      }

      fade = true

      get hips() {
        if ([BackgroundType.ESO_MILKY_WAY, BackgroundType.NONE].indexOf(this.type) < 0) {
          switch (this.type) {
            case BackgroundType.GAIA_DR2:
              return { surface: 'https://hscmap.mtk.nao.ac.jp/hscMap4/misc/hips/gaia' }
            case BackgroundType.KAWANOMOTO1:
              return {
                surface: 'https://hscmap.mtk.nao.ac.jp/hscMap4/misc/hips/kawanomoto/base',
                mask: "https://hscmap.mtk.nao.ac.jp/hscMap4/misc/hips/kawanomoto/mask",
              }
          }
          if (process.env.ENABLE_NHK) {
            const base = require('raw-loader!./nhk-url.txt').default as string
            if (this.type === BackgroundType.NHK2) {
              return { surface: `${base}/nhk2`, mask: `${base}/mask` }
            }
            for (const m = this.type.match(/^NHK(\d+)$/); m;) {
              return { surface: `${base}/nhk${m[1]}` }
            }
          }
        }
      }
    }
    return new FrameStore()
  }

  get outlet() {
    return {
      atmosphereLayer: AtmosphereLayer,
      backgroundMenu: BackgroundMenu,
    }
  }
}
